import { Controller, useFormContext } from 'react-hook-form';
import { ToastUIEditor } from '../toast-ui-editor'; // Import your ToastUIEditor component

// ----------------------------------------------------------------------

export function RHFToastEditor({ name, helperText, ...other }) {
    const {
        control,
        formState: { isSubmitSuccessful },
    } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <ToastUIEditor
                    {...field} // Pass field props like onChange and value
                    error={!!error}
                    helperText={error?.message ?? helperText}
                    resetValue={isSubmitSuccessful} // Reset value on successful submission
                    initialMarkdown={field.value || ''} // Initial markdown
                    {...other}
                />
            )}
        />
    );
}
